import { lazyLoad } from 'utils/loadable';

export const SalesDemoPage = lazyLoad(
  () => import('./index'),
  module => module.SalesDemoPage,
);
